import React from 'react'
import {Controller, UseFormMethods} from 'react-hook-form'
import BackgroundPicker from 'lib/ui/form/BackgroundPicker'
import CollapsibleSection from 'lib/ui/ConfigPanel/CollapsibleSection'
import Slider from 'lib/ui/Slider'
import {CountDownTimerSettings} from 'Event/Dashboard/components/CountDownTimer'

export default function UnitBackgroundSection(props: {
  control: UseFormMethods['control']
  countDownTimer: CountDownTimerSettings
  namePrefix?: string
}) {
  const {control, countDownTimer, namePrefix = ''} = props

  return (
    <CollapsibleSection label={'Unit Background'}>
      <Controller
        name={`${namePrefix}unitBackground.color`}
        control={control}
        defaultValue={countDownTimer.unitBackground.color}
        render={({value, onChange}) => (
          <BackgroundPicker
            label="Background"
            background={value}
            onChange={onChange}
          />
        )}
      />

      <Controller
        name={`${namePrefix}unitBackground.radius`}
        defaultValue={countDownTimer.unitBackground.radius}
        control={control}
        render={({value, onChange}) => (
          <Slider
            min={0}
            max={50}
            step={1}
            onChange={onChange}
            valueLabelDisplay="auto"
            value={value}
            unit="%"
            label="Radius"
          />
        )}
      />
      <Controller
        name={`${namePrefix}unitBackground.padding`}
        control={control}
        defaultValue={countDownTimer.unitBackground.padding}
        render={({value, onChange}) => (
          <Slider
            min={0}
            max={100}
            onChange={onChange}
            valueLabelDisplay="off"
            value={value}
            label="Padding"
            aria-label="number background padding"
          />
        )}
      />
      <Controller
        name={`${namePrefix}unitBackground.opacity`}
        control={control}
        defaultValue={countDownTimer.unitBackground.opacity || 100}
        render={({value, onChange}) => (
          <Slider
            min={0}
            max={100}
            onChange={onChange}
            valueLabelDisplay="off"
            value={value}
            label="Opacity"
            aria-label="unit background opacity"
          />
        )}
      />
    </CollapsibleSection>
  )
}
